module.exports = __webpack_public_path__ + "static/media/Orientamento.9625fcc7.png";